import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-transactions-title-with-pagination',
  templateUrl: './transactions-title-with-pagination.component.html',
  styleUrls: ['./transactions-title-with-pagination.component.scss'],
})
export class TransactionsTitleWithPaginationComponent {
  @Input() titleClasses = ''
  @Input() page = 1;
  @Output() pageChange = new EventEmitter<number>();

  @Input() itemsPerPage = 10;
  @Output() itemsPerPageChange = new EventEmitter<number>();

  @Input() desc: 0 | 1 = 1;
  @Output() descChange = new EventEmitter<0 | 1>();

  @Input() total = 0;

  @Input() loading = false;

  constructor() {}
}
